import { render, staticRenderFns } from "./bookingAgentCarrierForm.vue?vue&type=template&id=734eafb1&"
import script from "./bookingAgentCarrierForm.vue?vue&type=script&lang=js&"
export * from "./bookingAgentCarrierForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('734eafb1')) {
      api.createRecord('734eafb1', component.options)
    } else {
      api.reload('734eafb1', component.options)
    }
    module.hot.accept("./bookingAgentCarrierForm.vue?vue&type=template&id=734eafb1&", function () {
      api.rerender('734eafb1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/partner/tab/bookingAgentCarrierForm.vue"
export default component.exports